import { auditListRequest, auditListResponse } from '../../../../../backend/features/types/shared/auditList';
export const organizationsAuditListDef = {
    name: 'organizationsAuditList',
    requestSchema: auditListRequest,
    responseSchema: auditListResponse,
};
